var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AccountPropertySection,_vm._b({attrs:{"readable":_setup.readable,"on-validate":_setup.onValidate,"placeholder":_setup.t('settings', 'Your X (formerly Twitter) handle')}},'AccountPropertySection',_setup.value,false,true))
}
var staticRenderFns = []

export { render, staticRenderFns }